<template>
  <div class="card-options">
    <div class="card-options__list">
      <!-- Saved Cards -->
      <button
        v-for="(card, index) in entityCard"
        :key="index"
        class="card-options__item"
        @click="storeData(card)"
      >
        <div class="card-options__card-icon">
          <img
            v-if="card.type === 'VISA'"
            src="@/assets/img/visa.svg"
            alt="visa"
          />
          <img
            v-else-if="card.type === 'MASTERCARD'"
            src="@/assets/img/mastercard.svg"
            alt="mastercard"
          />
          <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="2" y="4" width="16" height="12" rx="2" stroke="currentColor" stroke-width="1.5"/>
            <path d="M2 8H18" stroke="currentColor" stroke-width="1.5"/>
          </svg>
        </div>
        <div class="card-options__content">
          <h4>**** **** **** {{ card.last_four }}</h4>
          <p>Expires {{ card.expiry }}</p>
        </div>
        <svg class="card-options__arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <!-- New Card Option -->
      <button class="card-options__item" @click="storeData">
        <div class="card-options__icon card-options__icon--add">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="1.5"/>
            <path d="M10 7V13M7 10H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="card-options__content">
          <h4>Use a New Card</h4>
          <p>Add a new debit or credit card</p>
        </div>
        <svg class="card-options__arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "CardOptionsForm",

  emits: ["storeData"],

  computed: {
    ...mapState({
      entityCard: (state) => state.organisationModule.entityCard,
    }),
  },

  methods: {
    ...mapActions("organisationModule", ["setCardDetails"]),

    storeData(card) {
      if (card.last_four) {
        this.setCardDetails(card);
        this.$emit("storeData", "storedCard");
      } else {
        this.$emit("storeData", "newCard");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Design System Variables
$text-primary: #0F172A;
$text-secondary: #475569;
$text-muted: #64748B;
$bg-card: #FFFFFF;
$bg-subtle: #F1F5F9;
$border-color: #E2E8F0;
$accent-primary: #6366F1;
$accent-light: #EEF2FF;

.card-options {
  padding: 8px 0;

  &__list {
    display: flex;
    flex-direction: column;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 16px 0;
    background: transparent;
    border: none;
    border-bottom: 1px solid $border-color;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: left;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: $bg-subtle;
      margin: 0 -16px;
      padding: 16px;
      width: calc(100% + 32px);
      border-radius: 10px;
      border-bottom-color: transparent;
    }
  }

  &__card-icon {
    width: 48px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $bg-subtle;
    border-radius: 10px;
    color: $text-secondary;
    flex-shrink: 0;

    &--add {
      background: $accent-light;
      color: $accent-primary;
    }
  }

  &__content {
    flex: 1;

    h4 {
      font-size: 14px;
      font-weight: 600;
      color: $text-primary;
      margin: 0 0 2px;
    }

    p {
      font-size: 13px;
      color: $text-muted;
      margin: 0;
    }
  }

  &__arrow {
    color: $text-muted;
    flex-shrink: 0;
    transition: transform 0.2s ease;
  }

  &__item:hover &__arrow {
    transform: translateX(2px);
  }
}
</style>
